import { IconPencil } from "@tabler/icons-react";
import Avatar from "../UI/Avatar";
import Text from "../UI/Text";
import styles from "./BailleurProfileCard.module.css";
import ProfileBadge from "./ProfileBadge";
import type { Profile } from "./types";
import {
  getAddress,
  getDisplayName,
  getInitials,
  getStatusLabel,
} from "./profileUtils";
import IconButton from "../UI/IconButton.tsx";
import FieldRow from "./FieldRow.tsx";
import ProfileFieldsGroup from "./ProfileFieldsGroup.tsx";

export type { Profile };

interface BailleurProfileCardProps {
  profile: Profile;
  onEdit?: (() => void) | null;
}

export default function BailleurProfileCard({
  profile,
  onEdit,
}: BailleurProfileCardProps) {
  const initials = getInitials(profile);
  const displayName = getDisplayName(profile);
  const statusLabel = getStatusLabel(profile);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <Avatar
          initials={initials}
          size="md"
          variant="yellow"
          className={styles.avatar}
        />
        {onEdit && (
          <IconButton
            onClick={onEdit}
            label="Modifier"
            icon={IconPencil}
            requiresWrite
          />
        )}
      </div>

      <div className={styles.body}>
        <div className={styles.titleRow}>
          <Text variant="base" weight="bold">
            {displayName}
          </Text>
          {statusLabel && <ProfileBadge>{statusLabel}</ProfileBadge>}
        </div>

        <ProfileFieldsGroup>
          <FieldRow label="Numéro de téléphone" value={profile.tel} />
          <FieldRow label="Adresse email" value={profile.mail} />
          <FieldRow label="Adresse" value={getAddress(profile)} />
        </ProfileFieldsGroup>
      </div>
    </div>
  );
}
